module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-05.88e87651.png";